import { render, staticRenderFns } from "./RelatedArticles.vue?vue&type=template&id=1668bc3f&scoped=true"
import script from "./RelatedArticles.vue?vue&type=script&setup=true&lang=ts"
export * from "./RelatedArticles.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RelatedArticles.vue?vue&type=style&index=0&id=1668bc3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1668bc3f",
  null
  
)

export default component.exports